import './styles.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';
import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

import { SellerType } from '@search/filter-enums/enums/SellerType';
import Image from '@search/vtbeco-frontend-core/view/common/components/Image';
import {
    SellerTypeEnum
} from '@search/graphql-typings';
import { IconVerified } from './icon/IconVerified';
import AnyAgent from './icon/AnyAgent.url.svg';
import IconOwner from './icon/IconOwner.url.svg';

const cn = classname.bind(null, 'AuthorBadge');

export function AuthorBadge({
    icon: iconRaw,
    name,
    verified,
    organizationName,
    category,
    enableTooltip,
    sellerLogoUrl
}: {
    organizationName?: string;
    category: SellerType;
    name: string;
    sellerLogoUrl?: string;
    verified?: boolean;
    icon?: React.ReactNode;
    enableTooltip?: boolean;
}) {
    const staticPath = useStaticPathConfig();
    const orgName = getAuthorDescription({ category, organizationName });
    const icon = iconRaw ?? <Image url={`${staticPath}${category === SellerType.OWNER ? IconOwner : AnyAgent}`} />;

    return (
        <div className={cn()}>
            <div className={cn('seller-logo')}>
                {sellerLogoUrl ? (
                    <img
                        src={sellerLogoUrl}
                        alt='картинка продавца'
                        crossOrigin='anonymous'
                        width='40px'
                        height='40px'
                    />
                ) : icon}
            </div>
            <div className={cn('seller')}>
                <div className={cn('name')}>
                    <Typography
                        variant='secondary-alone'
                        className={cn('overflow')}
                    >
                        {name}
                    </Typography>
                    {verified && (
                        <div className={cn('verified')}>
                            <IconVerified />
                        </div>
                    )}
                </div>
                {orgName && (
                    <Typography
                        variant='small-alone'
                        color='secondary'
                        className={cn('overflow')}
                    >
                        {orgName}
                    </Typography>
                )}
            </div>
        </div>
    );
}

export function getAuthorDescription({ name, organizationName: organizationNameRaw, category }: {
    name?: string | null;
    organizationName?: string | null;
    category: SellerType | 'UNKNOWN' | 'AGENT' | 'AGENCY' | 'OWNER' | 'DEVELOPER' | 'PIT' | 'AGGREGATOR';
}) {
    const organizationName = name && (organizationNameRaw === name) || organizationNameRaw === '...' ?
        undefined :
        organizationNameRaw;

    let description = organizationName ? ` ${organizationName}` : (name ? ` ${name}` : '');

    description = description.replace(/^(Агентство|Застройщик|Агент) /, '');

    if (category === SellerType.AGENCY || category === SellerTypeEnum.Agency) return `Агентство${description}`;
    if (category === SellerType.OWNER || category === SellerTypeEnum.Owner) return 'Собственник';
    if (category === SellerType.DEVELOPER || category === 'DEVELOPER') return `Застройщик${description}`;
    if (category === SellerType.AGENT || category === 'AGENT') return `Агент${description}`;

    return organizationName ?? undefined;
}
